import type { ProcurementLoad } from './types'

export function MyLoadPanel({ load }: { load: ProcurementLoad }) {
  const overloaded = load.total > load.limit
  const bars = [
    {
      label: 'Активные запросы',
      count: load.active.count,
      percent: load.active.percent,
      color: '#3b82f6',
    },
    {
      label: 'Ждут ответ поставщика',
      count: load.waiting.count,
      percent: load.waiting.percent,
      color: '#f59e0b',
    },
    {
      label: 'Готовы к квоте',
      count: load.ready.count,
      percent: load.ready.percent,
      color: '#10b981',
    },
  ]

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500 mb-3">Моя нагрузка</div>

      <div className="flex-1 space-y-3">
        {bars.map((b) => (
          <div key={b.label}>
            <div className="flex items-center justify-between text-sm mb-1">
              <span className="text-gray-700">{b.label}</span>
              <span className="text-gray-500 tabular-nums">
                {b.count} · {b.percent}%
              </span>
            </div>
            <div className="h-2 bg-gray-100 rounded overflow-hidden">
              <div
                className="h-full rounded transition-all"
                style={{ width: `${Math.max(2, b.percent)}%`, backgroundColor: b.color }}
              />
            </div>
          </div>
        ))}
      </div>

      <div
        className={`mt-4 pt-3 border-t border-gray-100 text-xs ${
          overloaded ? 'text-red-600 font-semibold' : 'text-gray-500'
        }`}
      >
        Всего в работе: <span className="tabular-nums">{load.total}</span> позиций · норма{' '}
        {load.limit}
        {overloaded && ' · перегрузка'}
      </div>
    </div>
  )
}
